import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=41aaf568&scoped=true&"
import script from "./VideoDetails.vue?vue&type=script&lang=js&"
export * from "./VideoDetails.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetails.vue?vue&type=style&index=0&id=41aaf568&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aaf568",
  null
  
)

export default component.exports